module.exports = __webpack_public_path__ + "static/media/plan-bg-part.4953fa57.svg";